import React, { useCallback, useContext, useEffect, useRef, useState } from "react";
import { StyledDrawer } from "../../../Repository/Repository";
import { IconButton } from "@mui/material";
import { t } from "i18next";
import { anchorPositions } from "../../../Help/HelpPanel";
import Split from "react-split";
import CloseIcon from "@mui/icons-material/Close";
import DatabaseNavigatorLeft from "./DatabaseNavigatorLeft";
import DatabaseNavigatorRight from "./DatabaseNavigatorRight";
import { encodingConstant } from "../../../../constants/constantList";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { useDispatch, useSelector } from "react-redux";
import { treeActions } from "../../../../redux/slices/treeSlice";
import { FIELD_TYPE } from "../../../../constants/datatypes";
import { api } from "../../../../redux/api";
import dayjs from "dayjs";
import { debounce } from "lodash";
import DatabaseViewer from "./DatabaseViewer";
import { Box } from "@mui/system";

const DatabaseNavigator = ({ open, handleClose, selectedConnection, alreadyConnected, showAlert, setConnectionLoading, selectedSchema, fromCustomDB = false, type = '', handleQuery, updateSchema, updateConnection, setOpenDrawer }) => {
  const parentScreen = useContext(ParentScreenCtx);
  const rightTree = useSelector((state) => state?.treeData?.[parentScreen]?.rightTree);
  const selectedNode = rightTree?.tree?.[rightTree?.currentTab]?.selectedNode;
  const [connection, setConnection] = useState('');
  const [schema, setSchema] = useState('');
  const [encoding, setEncoding] = useState(Object.keys(encodingConstant)[0]);
  const [selectedTable, setSelectedTable] = useState()
  const [sort, setSort] = useState(false);
  const [prepend, setPrepend] = useState(false);
  const [currTabTop, setCurrTabTop] = useState(0);
  const [currTabBottom, setCurrTabBottom] = useState(0);
  const [selectedMetaData, setSelectedMetaData] = useState([]);
  const [selectedCompareSQL, setSelectedCompareSQL] = useState([]);
  const [sqlQuery, setSqlQuery] = useState('');
  const [templateQuery, setTemplateQuery] = useState('');
  const [showQuery, setShowQuery] = useState(false);
  const dispatch = useDispatch();
  const queryRef = useRef();
  const [sqlActions, setSqlActions] = useState({
    runSqlScript: false,
    runTemplateScript: false
  })

  const sqlQueryHandler = (selectedNode) => {
    setShowQuery(false);
    queryRef.current = (selectedNode?.CLAUSE?.[0]?.VALUE);
    const dynamicValues = selectedNode?.CLAUSE?.[0]?.ARG || [];
    const loopGetDate = (i) => {
      if (i >= dynamicValues.length) return;
      const e = dynamicValues[i];
      if (queryRef.current.includes(e?.ARGNAME)) {
        if (e?.RECORD_TYPE === "SYSTEM_DATA" && e?.PATTERN) {
          dispatch(
            api.endpoints.validateDatePattern.initiate({
              datePattern: e?.PATTERN,
              select: e?.MAPNAME
            }, { forceRefetch: true, subscribe: true })
          ).then((response) => {
            if (response?.data?.current_state === "SUCCESS") {
              const date = response?.data?.message;
              queryRef.current = queryRef?.current?.replaceAll(e?.ARGNAME, `${date}`);
            }
            if (i === dynamicValues.length - 1) setTimeout(()=> setShowQuery(prev => true))
            else loopGetDate(i + 1);
          })
        }
        else if (i === dynamicValues.length - 1) setTimeout(()=> setShowQuery(prev => true))
        else loopGetDate(i + 1);
      }
      else if (i === dynamicValues.length - 1) setTimeout(()=> setShowQuery(prev => true))
      else loopGetDate(i + 1);
    }

    if (!dynamicValues.length) setTimeout(()=> setShowQuery(prev => true))
    else loopGetDate(0)
  }

  const generateQueryString = (node) => {
    let query = ' ';
    query = `${node?.TABLE_NAME || ''}.${node?.FIELD_NAME || ''} ${node?.COMPARE} ${node?.QUOTE_DATA ? `'${node?.VALUE?.trim() ? node?.VALUE : ""}'` : node?.VALUE || 'null'}`;
    if (!node?.TABLE_NAME || node?.TABLE_NAME === t('SELECT') || !node?.FIELD_NAME || node?.FIELD_NAME === t('SELECT'))
      return ''
    return query;
  }

  const debounceHandler = useCallback(debounce(sqlQueryHandler, 400), [
    rightTree.currentTab,
    rightTree.tree,
  ]);

  const updateQuery = () => {
    const recordExistingValue = queryRef?.current || '';
    const tables = [];
    const columns = [];
    const undefinedFields = [];
    const children = selectedNode?.children || [];
    const queryLink = selectedNode?.QUERY_LINK || [];
    const getQueryColumnAndTable = (table, column) => {
      if (column.includes('(')) return column;
      return `${table ? table + '.' : ''}${column}`
    }

    children.forEach(e => {
      if (FIELD_TYPE[e?.ICON_DISPLAY]) {
        if (e?.COLUMN_NAME) {
          columns.push(getQueryColumnAndTable(e?.TABLE_NAME, e?.COLUMN_NAME));
          if (!tables.includes(e?.TABLE_NAME)) tables.push(e?.TABLE_NAME);
        } else if (e?.TABLE_NAME && !e?.COLUMN_NAME) {
          if (!tables.includes(e?.TABLE_NAME)) tables.push(e?.TABLE_NAME);
          undefinedFields.push(e?.MAPNAME);
        } else undefinedFields.push(e?.MAPNAME);
      }
    })

    // Adding Columns to query
    let templateQuery = '';
    templateQuery += 'SELECT '
    columns.forEach((e, i) => {
      if (i < columns.length - 1) templateQuery += `${e}, `;
      else templateQuery += `${e} `;
    })

    let subQuery = "";
    queryLink.forEach((e, i) => {
      const query = generateQueryString(e);
      subQuery += `${query}${(i < (queryLink.length - 1) && query?.length) ? ' AND ' : ''}`
      if (!tables.includes(e?.TABLE_NAME)) tables.push(e?.TABLE_NAME);
      if (i === (queryLink.length - 1) && subQuery.lastIndexOf(' AND ') === subQuery.length - 5) {
        subQuery = subQuery.substring(0, subQuery.lastIndexOf('AND'));
      }
    })


    const lowercaseExistingQuery = recordExistingValue?.toLowerCase() || '';
    if (lowercaseExistingQuery?.trim()?.indexOf("from") === 0) {
      ;
      templateQuery += recordExistingValue;
      if (lowercaseExistingQuery?.trim()?.includes('where')) templateQuery += `${subQuery?.trim()?.length ? `AND ` + subQuery : ''}`;
      else templateQuery += `${(subQuery?.trim()?.length || undefinedFields?.length) ? ` WHERE ${subQuery}` : ''}`;
    }
    else if (lowercaseExistingQuery?.trim()?.indexOf("where") === 0
      || lowercaseExistingQuery?.trim()?.indexOf("order by") === 0) {
      templateQuery += 'FROM '
      tables.forEach((e, i) => {
        if (i < tables.length - 1) templateQuery += `${e}, `;
        else templateQuery += `${e} `;
      })
      templateQuery += `${recordExistingValue || ''}${subQuery.length && recordExistingValue?.length ? ' AND ' : ''}${subQuery}`

    }
    else {
      // Adding Tables to query
      templateQuery += 'FROM '
      tables.forEach((e, i) => {
        if (i < tables.length - 1) templateQuery += `${e}, `;
        else templateQuery += `${e} `;
      })

      // Adding Exstitng query into query
      if (recordExistingValue || subQuery.length)
        templateQuery += `WHERE ${recordExistingValue || ''}${subQuery.length && recordExistingValue?.length ? ' AND ' : ''}${subQuery}`
    }

    if (undefinedFields?.length) {
      // console.log(undefinedFields);
      templateQuery += t('DB_NAV_SQL_ERR').replaceAll('\\n', `\n`);
      templateQuery += `\n`;
      undefinedFields.forEach(e => {
        templateQuery += `${e}\n`;
      })
    }

    if (!queryLink?.length && !undefinedFields.length && !recordExistingValue?.trim() && !selectedNode?.children?.length) templateQuery = ''

    setSqlQuery(templateQuery);
    setTemplateQuery(templateQuery);
  }

  useEffect(() => {
    if (open) {
      setCurrTabBottom(0);
      setCurrTabTop(0);
      if (selectedConnection) setConnection(selectedConnection);
    } else {
      setSqlActions({
        runSqlScript: false,
        runTemplateScript: false
      })
    }
  }, [open])

  useEffect(() => {
    if (open) debounceHandler(selectedNode)
    else setShowQuery(false)
    setSelectedTable('');
  }, [open])

  useEffect(() => {
    if (open) debounceHandler(selectedNode)
  }, [selectedNode])

  useEffect(() => {
    if (showQuery) updateQuery();
  }, [showQuery])


  useEffect(() => {
    setSchema(selectedSchema || '');
  }, [selectedSchema, open])

  useEffect(() => {
    updateSchema(schema || '');
    setSchema(schema || '');
  }, [fromCustomDB, schema]);

  useEffect(() => {
    updateConnection(connection || '');
  }, [fromCustomDB, connection]);

  useEffect(() => {
    setConnection('');
    setSelectedTable('');
    if (open) debounceHandler(selectedNode)
  }, [selectedNode?.key])

  return (
    <StyledDrawer
      anchor={anchorPositions.left}
      open={open}
      onClose={handleClose}
      style={{ height: "100vh" }}
      className="height-100"
    >
      <Split
        className="split height-100 flex"
        direction="horizontal"
        gutterSize={4}
        snapOffset={0}
        dragInterval={4}
        minSize={[850, 0]}
        sizes={[67, 33]}
      >
        <div
          className="flex-column height-100"
          style={{ backgroundColor: "#fff" }}
        >
          <div
            style={{
              borderBottom: "1px solid #e0e0e0",
              height: "40px",
              boxSizing: "border-box",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              fontWeight: "500",
              paddingLeft: "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                fontSize: "18px",
                gap: "5px",
              }}
            >
              {t("DB_NAV_BUTTON")}
            </div>
            <IconButton onClick={handleClose} sx={{ borderRadius: "5px" }}>
              <CloseIcon
                sx={{ height: "28px", width: "28px", color: "#777777" }}
              />
            </IconButton>
          </div>
          <div
            style={{
              padding: "0 1rem",
              margin: "8px 0",
              fontSize: "14px",
              fontWeight: "normal",
            }}
          >
            {" "}
            {t('DB_NAV_DESC')}
            {" "}
          </div>
          <div
            className="height-100"
            style={{ padding: "0.5rem 1rem", overflow: 'hidden' }}
          >
            <Split
              className="split height-100 flex"
              direction="horizontal"
              gutterSize={4}
              snapOffset={0}
              dragInterval={4}
              minSize={[350, 60]}
              sizes={[35, 65]}
            >
              <div
                style={{
                  width: "500px",
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
                className="height-100 border-container"
              >
                <DatabaseNavigatorLeft
                  showQuery={showQuery}
                  modalOpen={open}
                  setConnectionLoading={setConnectionLoading}
                  showAlert={showAlert}
                  connection={connection}
                  alreadyConnected={alreadyConnected}
                  setConnection={setConnection}
                  schema={schema}
                  setSchema={setSchema}
                  encoding={encoding}
                  setEncoding={setEncoding}
                  selectedTable={selectedTable}
                  setSelectedTable={setSelectedTable}
                  sort={sort}
                  setSort={setSort}
                  prepend={prepend}
                  setPrepend={setPrepend}
                  selectedConnection={selectedConnection}
                  selectedSchema={selectedSchema}
                  fromCustomDB={fromCustomDB}
                />
              </div>
              {type !== 'CUSTOM_DB' ? <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignContent: "center",
                }}
                className="height-100"
              >
                <DatabaseNavigatorRight
                  showQuery={showQuery}
                  showAlert={showAlert}
                  setConnectionLoading={setConnectionLoading}
                  connection={connection}
                  setConnection={setConnection}
                  schema={schema}
                  setSchema={setSchema}
                  encoding={encoding}
                  setEncoding={setEncoding}
                  selectedTable={selectedTable}
                  setSelectedTable={setSelectedTable}
                  sort={sort}
                  setSort={setSort}
                  sqlQuery={sqlQuery}
                  templateQuery={templateQuery}
                  setSqlQuery={setSqlQuery}
                  setSqlActions={setSqlActions}
                  sqlActions={sqlActions}
                  currTabBottom={currTabBottom}
                  currTabTop={currTabTop}
                  setCurrTabBottom={setCurrTabBottom}
                  setCurrTabTop={setCurrTabTop}
                  selectedMetaData={selectedMetaData}
                  setSelectedMetaData={setSelectedMetaData}
                  prepend={prepend}
                  setPrepend={setPrepend}
                  selectedCompareSQL={selectedCompareSQL}
                  setSelectedCompareSQL={setSelectedCompareSQL}
                />
              </div> : <div
                style={{
                  width: "100%",
                  justifyContent: "center",
                  alignContent: "center",
                  border: "2px solid rgba(0, 0, 0, 0.12)"
                }}
                className="height-100"
              >
                <Box className="height-100">
                  <DatabaseViewer
                    selectedTable={selectedTable}
                    connection={connection}
                    alreadyConnected={alreadyConnected}
                    schema={schema}
                    selectedMetaData={selectedMetaData}
                    setSelectedMetaData={setSelectedMetaData}
                    encoding={encoding}
                    showAlert={showAlert}
                    prepend={prepend}
                    handleQuery={handleQuery}
                    setOpenDrawer={setOpenDrawer}
                  />
                </Box>
              </div>}
            </Split>
          </div>
        </div>
        <div></div>
      </Split>
    </StyledDrawer>
  );
};

export default DatabaseNavigator;
